import { useEffect, useState, useRef, useCallback } from "react";
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";

export default function ApproveImportedSpatialInfo() {
  const [unapprovedSplitAndMergeData, setUnapprovedSplitAndMergeData] = useState([]);
  const componentRef = useRef();
  const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [retrieve, setRetrieve] = useState(true);

  const navigate = useNavigate();

  // Utility: convert nested objects to strings
  const stringifyNestedObjects = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        newItem[key] = (typeof item[key] === "object" && item[key] !== null)
          ? JSON.stringify(item[key])
          : item[key];
      });
      return newItem;
    });
  };

  // Handle navigation to generate building permit certificate page
  const handleIssuePermit = useCallback((row) => {
    console.log("Opening generate building permit page for row:", row);
    
    // Navigate to the existing generateBuildingPermit page at /generatebuildingpermitcertificate
    // Pass the row data as state
    navigate("/generatebuildingpermitcertificate", {
      state: {
        permitData: row,
        // Pass the entire row object
        ...row
      }
    });
  }, [navigate]);

  // Add action columns - ONLY Issue Permit button
  const addActionColumnsSplitMerge = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      issuePermit: (
        <Button 
          variant="contained" 
          color="primary" 
          size="small"
          onClick={() => handleIssuePermit(item)}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '120px',
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            }
          }}
        >
          Issue Permit
        </Button>
      )
    }));
  }, [handleIssuePermit]);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      
      try {
        // Fetch building permit Data
        const buildingpermit = await GetDataFromApiWithParams("/buildingPermits");
        
        

        // ############################
       

            // Create buildingpermitnew by skipping unwanted attributes
            const buildingpermitnew = buildingpermit.map(item => {
              const { 
                consultant_comitment_path,
                contractor_comitment_path, 
                owner_commitment_path, 
                plan_archtectural_path, 
                plan_electrical_path, 
                plan_electro_mechanical_path, 
                plan_environmental_path, 
                plan_other_path, 
                plan_sanitary_path, 
                plan_structural_path, 
                other_bldg_description,
                modification_details,
                description,
                ...rest 
              } = item;
              return rest;
            });
        // ##########################
        
        if (buildingpermit && Array.isArray(buildingpermit) && buildingpermit.length > 0) {
          console.log("Raw building permits data:", buildingpermit);
          
          const formattedSplitMergeData = stringifyNestedObjects(buildingpermitnew);
          const splitMergeDataWithActions = addActionColumnsSplitMerge(formattedSplitMergeData);
          setUnapprovedSplitAndMergeData(splitMergeDataWithActions);
          
          // Get base columns (excluding action columns that will be added by IPDCFinalTable)
          const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
            ? Object.keys(formattedSplitMergeData[0]).filter(col => col !== 'issuePermit')
            : [];
          
          // Set columns: ONLY issuePermit button
          setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "issuePermit"]);
          
          console.log("Processed building permits data:", splitMergeDataWithActions);
        } else {
          console.log("No building permits data found");
          setUnapprovedSplitAndMergeData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load data. Please try again.", {
          position: "top-right",
          autoClose: 8000
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [addActionColumnsSplitMerge]);

  return (
    <Box sx={{ p: 2 }}>
      <ToastContainer 
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>Loading Data</div>
      ) : (
        <>
          <div style={{ 
            borderBottom: '2px solid #e0e0e0', 
            margin: '30px 0',
            width: '100%' 
          }} />

          <div>
            <h3 style={{ marginBottom: '15px', color: '#333' }}></h3>
            
            {unapprovedSplitAndMergeData.length > 0 ? (
              <IPDCFinalTable
                ref={componentRef}
                data={unapprovedSplitAndMergeData}
                setData={setUnapprovedSplitAndMergeData}
                selectedColumns={selectedColumnsSplitMerge}
                title="Building Permit Lists"
                attachmentLink="file_path"
                hasAttachment={false}
              />
            ) : (
              <div style={{ 
                padding: '20px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                textAlign: 'center',
                color: '#666'
              }}>
                No building permit applications found
              </div>
            )}
          </div>
        </>
      )}
    </Box>
  );
}